import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

export const IconCustom = styled(Icon)`
  margin-right: 8px;
`
